<template>
  <div class="guides-page">
    <!-- Start Page Title -->

    <div
      class="bg-img-div"
      v-bind:style="{ 'background-image': 'url(' + img + ') !important' }"
    ></div>
    <div class="page-title-area">
      <div class="container">
        <div class="row">
          <div class="col-md-6 text-hero">
            <h2 class="title">
              Our Authors
            </h2>
            <p class="subtitle">
              Discover these authors who are providing more for their readers to
              explore.
            </p>
            <div class="form-group search">
              <b-form-input
                placeholder="Search by name, experience, etc."
                autocomplete="off"
                @focus="show.suggestion = true"
                @blur="show.suggestion = false"
                v-model="searchTerm"
              ></b-form-input>
              <transition name="slide-fade">
                <div class="search-suggestion" v-if="show.suggestion">
                  <div
                    v-if="searchedGuides.length == 0 && searchTerm.trim() == ''"
                  >
                    Search by Name, tag or experience.
                  </div>
                  <div
                    v-if="
                      searchedGuides.length == 0 && searchTerm.trim() !== ''
                    "
                  >
                    No Guides Found.
                  </div>
                  <div v-if="searchedGuides.length > 0">
                    <h4 class="headline">Searched Guides</h4>
                    <div
                      class="guides__search"
                      v-for="(guide, index) in searchedGuides"
                      :key="index"
                    >
                      <div
                        @click="handleGuideClick(guide)"
                        class="single-guide__search"
                      >
                        <img
                          :src="guide.user.imgURL"
                          :alt="guide.user.firstname"
                        />
                        <div class="info">
                          <h3 class="name">
                            {{ guide.user.firstname }}
                            {{ guide.user.lastname }}
                          </h3>
                          <h5 class="category">Education</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="tags">
              <span class="tag">Tags</span>
              <b-link
                :class="selectedTag == 'all' ? 'selected-tag' : ''"
                @click="setGuidesByTag('all')"
                >All</b-link
              >
              <b-link
                :class="selectedTag == 'spiritual' ? 'selected-tag' : ''"
                @click="setGuidesByTag('spiritual')"
                >Spiritual</b-link
              >
              <b-link
                :class="selectedTag == 'health' ? 'selected-tag' : ''"
                @click="setGuidesByTag('health')"
                >Self Help</b-link
              >
              <b-link
                :class="selectedTag == 'education' ? 'selected-tag' : ''"
                @click="setGuidesByTag('education')"
                >Education</b-link
              >
              <b-link
                :class="selectedTag == 'finance' ? 'selected-tag' : ''"
                @click="setGuidesByTag('finance')"
                >Finance</b-link
              >
            </div>
          </div>
          <div class="col-md-6">
            <lottie-animation
              :path="heroLottiePath"
              :loop="true"
              :autoPlay="true"
              width="500"
              height="500"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- End Page Title -->

    <!-- Start Guides Area -->
    <section class="team-area ptb-80 pt-0">
      <div class="container">
        <div class="sub-heading">
          <h3>Top Authors</h3>
        </div>
        <div class="top-guides">
          <div v-for="aGuide in allGuides.slice(0, 5)" :key="aGuide.id">
            <div class="top-guide" @click="handleGuideClick(aGuide)">
              <div class="img__top-guide">
                <img :src="aGuide.user.imgURL" :alt="aGuide.user.firstname" />
                <!-- <span class="ico ico__badge">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="10" cy="10" r="10" fill="white" />
                    <circle cx="10" cy="10" r="8" fill="#557EFB" />
                    <path
                      d="M6.96465 6.5588C6.96465 7.98468 8.8714 9.74011 9.99653 10.4558C11.2063 9.67641 13.0135 8.3382 13.0135 6.72058C13.0135 5.95236 12.5654 5 11.6394 5C10.8986 5 10.3102 5.32355 9.99653 5.91175C9.66795 5.30884 8.8017 5 8.38351 5C7.96532 5 6.96464 5 6.96465 6.5588Z"
                      stroke="white"
                      stroke-width="0.6"
                    />
                    <path
                      d="M7.86077 12.9116C7.83588 12.7793 7.57701 12.3381 7.57701 12.3381L6.72568 11.5293C6.72568 11.5293 6.27763 11.0587 6.00879 10.7499C5.73995 10.4411 5.71508 10.1617 5.78478 9.98522C5.82712 9.87801 5.97894 9.79405 6.03868 9.79405M6.03868 9.79405C6.11336 9.77934 6.30752 9.8088 6.42698 9.9264C6.56142 10.0588 7.20362 10.6911 7.57701 11.0587C7.95039 11.4264 9.14525 11.9117 9.35434 12.4264C9.56344 12.9411 9.41408 14.191 9.41408 15.044L7.33804 15.0587C7.40276 14.8234 7.33804 14.3381 7.33804 13.9116C7.33804 13.251 6.57635 12.6911 6.33739 12.5146C6.09843 12.3381 5.08279 11.5293 5.08279 11.0587C5.08278 10.1451 4.94721 8.38077 5.02306 7.76467C5.08281 7.27939 5.14253 7.01468 5.41137 7.11762C5.68021 7.22056 5.79969 7.43527 5.79969 7.8235C5.79969 8.21173 5.96898 9.29997 6.03868 9.79405Z"
                      stroke="white"
                      stroke-width="0.6"
                    />
                    <path
                      d="M12.1392 12.9116C12.1641 12.7793 12.423 12.3381 12.423 12.3381L13.2743 11.5293C13.2743 11.5293 13.7224 11.0587 13.9912 10.7499C14.26 10.4411 14.2849 10.1617 14.2152 9.98522C14.1729 9.87801 14.0211 9.79405 13.9613 9.79405M13.9613 9.79405C13.8866 9.77934 13.6925 9.8088 13.573 9.9264C13.4386 10.0588 12.7964 10.6911 12.423 11.0587C12.0496 11.4264 10.8548 11.9117 10.6457 12.4264C10.4366 12.9411 10.5859 14.191 10.5859 15.044L12.662 15.0587C12.5972 14.8234 12.662 14.3381 12.662 13.9116C12.662 13.251 13.4236 12.6911 13.6626 12.5146C13.9016 12.3381 14.9172 11.5293 14.9172 11.0587C14.9172 10.1451 15.0528 8.38077 14.9769 7.76467C14.9172 7.27939 14.8575 7.01468 14.5886 7.11762C14.3198 7.22056 14.2003 7.43527 14.2003 7.8235C14.2003 8.21173 14.031 9.29997 13.9613 9.79405Z"
                      stroke="white"
                      stroke-width="0.6"
                    />
                  </svg>
                </span> -->
              </div>
              <div class="info__top-guide">
                <h3>{{ aGuide.user.firstname }} {{ aGuide.user.lastname }}</h3>
                <div v-if="aGuide.profile && aGuide.profile.rating">
                  <span
                    class="ico filled"
                    v-for="(star, index) in aGuide.profile.rating"
                    :key="index"
                  >
                    <svg
                      width="15"
                      height="14"
                      viewBox="0 0 15 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.3942 4.9298L9.93499 4.29107L7.94159 0.308118C7.88715 0.199068 7.79758 0.110788 7.68693 0.0571283C7.40943 -0.0778871 7.07223 0.0346257 6.93348 0.308118L4.94008 4.29107L0.480846 4.9298C0.357906 4.94711 0.245503 5.00423 0.159444 5.09078C0.0554043 5.19617 -0.0019265 5.33796 4.94326e-05 5.48499C0.00202536 5.63202 0.0631463 5.77227 0.169982 5.87491L3.3963 8.97507L2.63407 13.3527C2.61619 13.4545 2.62762 13.5592 2.66707 13.655C2.70652 13.7508 2.77239 13.8337 2.85724 13.8944C2.94208 13.9552 3.04249 13.9912 3.14708 13.9986C3.25167 14.0059 3.35626 13.9843 3.44899 13.936L7.43754 11.8692L11.4261 13.936C11.535 13.9931 11.6614 14.0122 11.7826 13.9914C12.0882 13.9395 12.2937 13.6539 12.241 13.3527L11.4788 8.97507L14.7051 5.87491C14.7929 5.79009 14.8509 5.67931 14.8684 5.55814C14.9158 5.25522 14.7016 4.9748 14.3942 4.9298Z"
                        fill="#F8D57C"
                      />
                    </svg>
                  </span>
                  <span
                    class="ico empty"
                    v-for="(star, index) in 5 - aGuide.profile.rating"
                    :key="index + 5"
                  >
                    <svg
                      width="15"
                      height="14"
                      viewBox="0 0 15 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.3942 4.9298L9.93499 4.29107L7.94159 0.308118C7.88715 0.199068 7.79758 0.110788 7.68693 0.0571283C7.40943 -0.0778871 7.07223 0.0346257 6.93348 0.308118L4.94008 4.29107L0.480846 4.9298C0.357906 4.94711 0.245503 5.00423 0.159444 5.09078C0.0554043 5.19617 -0.0019265 5.33796 4.94326e-05 5.48499C0.00202536 5.63202 0.0631463 5.77227 0.169982 5.87491L3.3963 8.97507L2.63407 13.3527C2.61619 13.4545 2.62762 13.5592 2.66707 13.655C2.70652 13.7508 2.77239 13.8337 2.85724 13.8944C2.94208 13.9552 3.04249 13.9912 3.14708 13.9986C3.25167 14.0059 3.35626 13.9843 3.44899 13.936L7.43754 11.8692L11.4261 13.936C11.535 13.9931 11.6614 14.0122 11.7826 13.9914C12.0882 13.9395 12.2937 13.6539 12.241 13.3527L11.4788 8.97507L14.7051 5.87491C14.7929 5.79009 14.8509 5.67931 14.8684 5.55814C14.9158 5.25522 14.7016 4.9748 14.3942 4.9298Z"
                        fill="#dddddd"
                      />
                    </svg>
                  </span>
                </div>
                <div v-else>
                  Not Rated
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="sub-heading">
          <h3>Search Results</h3>
        </div>
        <div v-if="guidesToDisplay.length > 0" class="row">
          <div
            v-for="(aGuide, index) in guidesToDisplay.slice(
              start,
              start + perPage
            )"
            :key="index"
            class="col-lg-3 col-md-4 col-sm-6"
          >
            <guide-card :aGuide="aGuide"></guide-card>
          </div>
        </div>
        <div v-else>
          No Guides found.
        </div>
      </div>
    </section>
    <!-- End Guides Area -->
    <!-- Start Pagination Area -->
    <pagination
      v-if="totalPages > 1"
      :length="totalPages"
      @page-changed="changePage"
    ></pagination>
    <!-- End Pagination Area -->
    <video-modal></video-modal>
  </div>
</template>

<script>
import GuideCard from "@/components/other-pages/guides/GuideCard";
import Pagination from "@/components/other-pages/guides/Pagination";
import VideoModal from "@/components/other-pages/guides/VideoModal";
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"; // import lottie-vuejs
import config from "@/assets/_config.json";
export default {
  name: "guides",
  data() {
    return {
      img: require("@/assets/img/guides-bg.jpg"),
      show: {
        suggestion: false
      },
      totalPages: 0,
      allGuides: [],
      guidesToDisplay: [],
      searchTerm: "",
      start: 0,
      perPage: 12,
      selectedTag: null,
      config
    };
  },
  components: {
    GuideCard,
    LottieAnimation,
    Pagination,
    VideoModal
  },
  mounted() {
    this.getGuides();
    this.setHeight();
    setTimeout(() => {
      this.setHeight();
    }, 1500);
    let that = this;
    (function() {
      that.setHeight();
    })();
    window.addEventListener("resize", () => {
      this.setHeight();
    });
    window.addEventListener("scroll", () => {
      this.setHeight();
    });
  },
  watch: {
    guidesToDisplay(newValue, oldValue) {
      this.totalPages = Math.ceil(newValue.length / this.perPage);
    }
  },
  computed: {
    searchedGuides() {
      let guides = [];
      if (this.searchTerm == "") {
        return guides;
      }
      let search = this.searchTerm.toLowerCase();
      this.allGuides.forEach(guide => {
        if (
          guide.user.firstname.toLowerCase().includes(search) ||
          guide.user.lastname.toLowerCase().includes(search)
        ) {
          guides.push(guide);
        }
        if (guide.profile && guide.profile.tags) {
          guide.profile.tags.forEach(tag => {
            if (tag.text.toLowerCase().includes(search)) {
              guides.push(guide);
            }
          });
        }
        if (guide.profile && guide.profile.plans) {
          guide.profile.plans.forEach(plan => {
            if (plan.details.toLowerCase().includes(search)) {
              guides.push(guide);
            }
          });
        }
      });
      const uniq = new Set(guides.map(e => JSON.stringify(e)));
      const uniqueGuides = Array.from(uniq).map(e => JSON.parse(e));
      return uniqueGuides;
    },
    heroLottiePath() {
      //will be based on selection in the future- health, spiritual, etc
      //Cached images
      switch (Math.floor(Math.random() * Math.floor(2))) {
        case 1:
          return "assets/lotties/beetle-guide-ant.json";
        default:
          return "assets/lotties/guide-management.json";
      }
    }
  },
  methods: {
    getGuides() {
      this.$store
        .dispatch("listings/getListGuides")
        .then(res => {
          this.allGuides = res;
          this.guidesToDisplay = res;
        })
        .catch(e => {
          console.log(e);
        });
    },
    changePage(page) {
      this.start = page * this.perPage - this.perPage;
    },
    setHeight() {
      document.querySelector(".bg-img-div").style.height =
        document.querySelector(".page-title-area").clientHeight + "px";
    },
    setGuidesByTag(input) {
      this.selectedTag = input;
      if (input == "all") {
        this.guidesToDisplay = this.allGuides;
      } else {
        this.guidesToDisplay = [];
        this.allGuides.forEach(guide => {
          if (guide.profile && guide.profile.tags) {
            guide.profile.tags.forEach(tag => {
              if (tag.text.toLowerCase().includes(input)) {
                this.guidesToDisplay.push(guide);
              }
            });
          }
        });
      }
    },
    handleGuideClick(crew) {
      this.$router.push(`/crew/@${crew.profile.profileName}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.guides-page {
  .bg-img-div {
    // margin-top: 120px;
    background-image: url("../../../assets/img/guides-bg.jpg") !important;
    background-position: right bottom;
    background-repeat: no-repeat;
    background-size: contain;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
  }
  .hero-img {
    max-height: 334px;
  }
  .text-hero {
    padding-top: 60px;
    // min-height: 504px ;
    // display: flex;
    // align-items: flex-start;
    // justify-content: center;
    // flex-direction: column;
  }
  .selected-tag {
    font-weight: bold;
    font-size: large;
    color: #fff !important;
    background: #557efb;
    border-radius: 10px;
  }
  .page-title-area {
    // padding-top: 152px;
    padding-top: 72px;
    position: relative;
    background: none !important;
    .bg-img {
      display: none;
      width: 100%;
      position: absolute;
      left: 0;
      width: 100%;
      object-fit: cover;
      bottom: 0;
      object-position: right bottom;
      // ob
      z-index: -1;
    }
    .title {
      color: #52595e;
      text-align: left;
      font-size: 32px;
    }
    .subtitle {
      font-size: 16px;
      line-height: 22px;
      text-align: left;
      color: #8d99a0;
      margin: 16px 0;
      max-width: 450px;
      margin-bottom: 32px;
    }
    .form-group {
      margin-top: 16px;
      &.search {
        position: relative;
        .search-suggestion {
          position: absolute;
          top: 100%;
          left: 0;
          width: 100%;
          max-width: 529px;
          min-height: 100px;
          background-color: #fff;
          z-index: 9;
          filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.08));
          border-radius: 0 0 40px 40px;
          padding: 32px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          // z-index: 2;
          .headline {
            font-family: "Nunito", sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            letter-spacing: 0.1em;
            color: #52595e;
            text-transform: capitalize;
          }
          .guides__search {
            padding: 16px 0;
            .single-guide__search {
              display: grid;
              grid-template-columns: 40px 1fr;
              grid-column-gap: 16px;
              cursor: pointer;
              img {
                height: 40px;
                width: 40px;
                border-radius: 50%;
                object-fit: cover;
              }
              .category,
              .name {
                font-family: "Nunito", sans-serif;
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                line-height: 22px;
                color: #52595e;
                text-align: left;
                margin: 0;
              }
              .category {
                font-size: 13px;
                font-weight: bold;
                color: #a1b1ba;
              }
            }
          }
        }
      }
    }
    .tags {
      text-align: left;
      a,
      .tag {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #8d99a0;
        margin-right: 24px;
        padding: 0px 3px;
      }
      a {
        color: #557efb;
      }
    }
  }

  .team-area {
    position: relative;
    // z-index: 2;
    // margin-top: -130px;

    .top-guides {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      grid-column-gap: 20px;

      .top-guide {
        cursor: pointer;
        box-shadow: 0px 12px 16px rgba(45, 38, 38, 0.04);
        border-radius: 8px;
        padding: 24px 0 24px 12px;
        display: grid;
        grid-template-columns: 56px 140px;
        grid-column-gap: 16px;
        transition: 0.5s;
        margin-bottom: 5px;
        background-color: #fff;
        &:hover {
          box-shadow: 0px 12px 16px rgba(45, 38, 38, 0.1);
        }
        .img__top-guide {
          position: relative;
          img {
            width: 56px;
            height: 56px;
            border-radius: 50%;
            object-fit: cover;
          }
          .ico__badge {
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translate(25%, 25%);
          }
        }
        .info__top-guide {
          .ico {
            margin-right: 3px;
          }
          h3 {
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 22px;
            color: #52595e;
            text-transform: capitalize;
          }
        }
      }
    }
    .sub-heading {
      margin: 15px 0px;
      h3 {
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 27px;
        color: #52595e;
      }
    }

    .main-line {
      margin-top: 5px;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      color: #8d99a0;
      span {
        color: #557efb;
        text-transform: lowercase;
      }
    }
  }
  .rating {
    margin: 8px 0;
    .ico {
      margin: 0 4px;
    }
  }
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
@media (min-width: 1024px) {
  .team-area {
    margin-top: -130px;
  }
}
</style>
